'use client';

import React, { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import Trans from '../Trans';
import { MainNavProps } from '@/types/dataTypes';
import { checkMobilePhone } from '@/lib/deviceManager';

export function MainNav({ navData, taobaoSite, jingdongSite }: MainNavProps) {
	useEffect(() => {
		if (checkMobilePhone()) {
			window.location.href = '/m';
		}
	}, []);

	useEffect(() => {
		import('preline');
	}, []);

	const pathname = usePathname() ?? '';

	const [language, setLanguage] = useState(
		(typeof window !== 'undefined' &&
			window.localStorage.getItem('language')) ||
			's'
	); // s简体 t繁体
	const pv = useRef<Trans | null>(null);
	useEffect(() => {
		pv.current = new Trans(language);
		pv.current.zh_init();
	}, [language, pathname]);

	const [imageSrc, setImageSrc] = React.useState('/ico03.png');

	const changeTmallImg = () => {
		setImageSrc('/ico04.png');
	};
	const resumeTmallImg = () => {
		setImageSrc('/ico03.png');
	};

	return (
		<header className="relative flex flex-wrap z-50 w-full bg-white text-sm h-[102px]">
			<nav
				className="max-w-[100rem] w-full mx-auto px-4 flex items-center"
				aria-label="Global"
			>
				<div className="flex items-center justify-between">
					<Link className="flex-none" href="/">
						<Image
							className="w-[324px] h-[49px]"
							width={324}
							height={49}
							alt="Logo"
							src="/webLogo.jpg"
							quality={100}
						></Image>
					</Link>
				</div>
				<div className="transition-all duration-300 grow h-full mr-4">
					<div className="flex flex-row justify-end text-base h-full">
						{navData.map((link, index, array) => (
							<div
								className={`${
									link.subTitles.length > 0
										? 'hs-dropdown [--strategy:absolute] [--adaptive:none] [--trigger:hover]'
										: ''
								}  flex justify-center h-full`}
								key={link.title}
							>
								<button
									id="hs-mega-menu-basic-dr"
									type="button"
									className="flex items-center w-full text-[#323232] hover:text-[#005BAC] font-medium relative"
								>
									<Link
										className="w-full h-full flex flex-row items-center"
										href={link.href}
										target={
											link.href.includes('http')
												? '__blank'
												: ''
										}
									>
										<div className="w-full px-7">
											{link.title}
										</div>
										{index !== array.length - 1 && (
											<div className="h-[14px] w-[0.5px] bg-[#aeb0b3]"></div>
										)}
									</Link>

									{pathname.length > 1 &&
										link.href.length > 1 &&
										!link.href.includes('http') &&
										pathname.includes(
											link.href.split('/')[1]
										) && (
											<div className="absolute bottom-[-1px] left-1/2 transform translate-x-[-50%] w-[64px] h-[3px] bg-[#1d476d]"></div>
										)}
								</button>

								{link.subTitles.length > 0 && (
									<div className="hs-dropdown-menu transition-[opacity,margin] duration-[150ms] hs-dropdown-open:opacity-100 opacity-0 w-40 hidden z-10 bg-white shadow-md top-full before:absolute before:-top-[3px] before:left-0 before:w-full before:h-[0px] before:border-b-[3px]  before:border-[#0c5caa]">
										{link.subTitles.map((link) => (
											<div
												key={link.href}
												className="group flex justify-center items-center gap-x-3.5 text-xs text-[#7A7A7A] h-12 hover:bg-gray-100 border-b-[1px] border-[#e9e9e9] mx-auto leading-none"
											>
												<Link
													className="transition-all duration-300 group-hover:mr-5 h-full w-full flex justify-center items-center"
													href={link.href}
													target={
														link.href.includes(
															'http'
														)
															? '__blank'
															: ''
													}
												>
													{link.title}
												</Link>

												<Image
													className="absolute right-5 transition duration-500  group-hover:opacity-100 opacity-0"
													width="5"
													height="7"
													alt="nav_next"
													src="/ico01.png"
													quality={100}
												></Image>
											</div>
										))}
									</div>
								)}
							</div>
						))}
					</div>
				</div>

				{/* <div
					className="flex flex-none justify-center items-center w-10 h-3.5 border-r border-[#aeb0b3]"
					onMouseOver={changeTmallImg}
					onMouseOut={resumeTmallImg}
				>
					<Image
						width="14"
						height="14"
						alt="nav_search"
						quality={100}
						className=""
						src="/ico02.png"
					></Image>
				</div> */}

				<div
					className="flex flex-row flex-none items-center text-xs w-fit h-12 "
					onMouseOver={changeTmallImg}
					onMouseOut={resumeTmallImg}
				>
					<Image
						width="5"
						height="5"
						alt="nav_tmall"
						quality={100}
						className="ml-4 hover:cursor-pointer hover:opacity-50"
						src={imageSrc}
					></Image>
					<Link
						className="ml-4 pr-4 line-clamp-1 border-r border-[#aeb0b3] w-full text-[#5e6267] hover:text-[#005bac]"
						href={taobaoSite}
						target="__blank"
					>
						天猫商城
					</Link>
					<Link
						className="ml-4 pr-4 border-r border-[#aeb0b3] w-full text-[#5e6267] hover:text-[#005bac]"
						href={jingdongSite}
						target="__blank"
					>
						京东商城
					</Link>
				</div>

				<div className="flex flex-row flex-none justify-center items-center text-xs w-20 h-12 ">
					<button
						className="mr-1 text-[#5e6267] hover:text-[#005bac]"
						onClick={() => {
							setLanguage('s');
							global.localStorage.setItem('language', 's');
						}}
					>
						简
					</button>
					/
					<button
						className="ml-1 text-[#5e6267] hover:text-[#005bac]"
						onClick={() => {
							setLanguage('t');
							global.localStorage.setItem('language', 't');
						}}
					>
						繁
					</button>
				</div>
			</nav>
		</header>
	);
}
